import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["password", "confirmation"]
  static values = { mismatchMessage: String }

  validate() {
    this.check(false)
  }

  validateAndShow() {
    this.check(true)
  }

  onSubmit(event) {
    if (!this.check(true)) {
      event.preventDefault()
      event.stopPropagation()
      this.confirmationTarget.focus()
    }
  }

  check(showMessage) {
    const confirmation = this.confirmationTarget
    const mismatch = confirmation.value && confirmation.value !== this.passwordTarget.value
    confirmation.setCustomValidity(mismatch ? this.mismatchMessageValue : "")
    if (showMessage && confirmation.validationMessage) confirmation.reportValidity()
    return !confirmation.validationMessage
  }
}
